/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidTemplate/PyramidInputInterpreter',['absolute/debug',
        'Arkadium/GameEngine/Core/EngineManagers',
        'SolitaireShared/CardLogic/CardAction',
        'SolitaireShared/CardLogic/CardValue',
        'SolitaireShared/CardLogic/CardOp'],
    function (Debug, EngineManagers, CardAction, CardValue, CardOp) {
        "use strict";

        var PyramidInputInterpreter = function (authority) {
            this.initPyramidInputInterpreter(authority);
        };

        PyramidInputInterpreter.DoubleClickThreshold = 700;

        PyramidInputInterpreter.prototype.initPyramidInputInterpreter = function (authority) {
            this.Authority = authority;

            this.IsClickedOnCard = false;
            this.InputEnabled = true;

            this.HighlightedCard = null;
            this.HighlightTime = -1;
        };


        PyramidInputInterpreter.prototype.NotifyCardsMoved = function () {
            this.ClearHighlight();
        };

        PyramidInputInterpreter.prototype.Drag = function (cardDragged, distance) {
            return true;
        };

        PyramidInputInterpreter.prototype.Drop = function (cardDropped, dropPiles) {
            var supply = cardDropped.Card.Supply;
            var action = new CardAction(supply);
            action.Parse(["noop"]);
            return action;
        };

        PyramidInputInterpreter.prototype.ClickCard = function (cardClicked, rightClicked) {
            //System.Diagnostics.Debug.WriteLine("Card: " + cardClicked.Card.ToString());
            var supply = cardClicked.Card.Supply;
            var action = new CardAction(supply);
            action.Parse(["noop"]);
            if (cardClicked.Animating)
                return action;
            if (rightClicked) {
                // do nothing on a right click
                return action;
            }

            if (!this.InputEnabled) return action;

            /*if (cardClicked.Card.Pile.Type == "Stock")
             {
             action.Parse("move", cardClicked.Card.Pile.Name, "Waste", "1");
             ClearHighlight();
             }
             else */
            if (cardClicked.Card.Pile.Type == "Tableau"
                || cardClicked.Card.Pile.Type == "Waste"
                || cardClicked.Card.Pile.Type == "Stock"
                || cardClicked.Card.Pile.Type == "Joker") {
                if (cardClicked.Card.Pile.Type != "Tableau" || !this.Authority.IsTableauBlocked(cardClicked.Card.Pile)) {
                    // if the card is not in a tableau, or is not blocked
                    // (i.e. if the card IS in a tableau and IS blocked, disallow everything)

                    if (this.IsCardHighlighted()) {
                        if (this.HighlightedCard == cardClicked) {
                            if (cardClicked.Card.Pile.Type == "Stock") {
                                var CurrentTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
                                if (CurrentTime - this.HighlightTime < PyramidInputInterpreter.DoubleClickThreshold) {
                                    action.Parse(["begin", "move", "Stock", "Waste", "1", "end"]);
                                    if (action.IsAllowed()) {
                                        EngineManagers.Sounds.PlaySound("singleCard");
                                        this.ClearHighlight();
                                    }
                                }
                                else {
                                    this.ClearHighlight();
                                    EngineManagers.Sounds.PlaySound("deselectCard");
                                }
                            }
                            else {
                                this.ClearHighlight();
                                EngineManagers.Sounds.PlaySound("deselectCard");
                            }
                        }
                        else if (cardClicked.Card.Value == CardValue.Values.King) {
                            action.Parse(["move", cardClicked.Card.Pile.Name, "Foundation", "1"]);
                            this.ClearHighlight();
//#if WIN8
                            if (action.IsAllowed()) {
                                EngineManagers.Sounds.PlaySound("flipCardOffScreen");
                                EngineManagers.Sounds.PlaySound("matchCard1");
                            }
//#endif
                        }
                        else {
                            if (this.GetHighlightedCard() != cardClicked) {
                                var firstCard = this.GetHighlightedCard();
                                action.Parse(["begin",
                                    "move", firstCard.Card.Pile.Name, "Foundation", "1",
                                    "move", cardClicked.Card.Pile.Name, "Foundation", "1",
                                    "end"]);

                                this.HighlightCard(cardClicked);
//#if WIN8
                                if (action.IsAllowed()) {
                                    this.PlayMatchSound(cardClicked.Card.Pile.Type == "Joker" || firstCard.Card.Pile.Name == "Joker");
                                    EngineManagers.Sounds.PlaySound("flipCardOffScreen");
                                }
//#endif
                            }
                        }
                    }
                    else {
                        // no card highlighted
                        if (cardClicked.Card.Value == CardValue.Values.King) {
                            action.Parse(["move", cardClicked.Card.Pile.Name, "Foundation", "1"]);
                            this.ClearHighlight();
//#if WIN8
                            if (action.IsAllowed()) {
                                EngineManagers.Sounds.PlaySound("flipCardOffScreen");
                                EngineManagers.Sounds.PlaySound("matchCard1");
                            }
//#endif
                        }
                        else {
                            this.HighlightCard(cardClicked);
                        }
                    }
                }
            }

            return action;
        };

        PyramidInputInterpreter.prototype.PlayMatchSound = function (isJoker) {
            EngineManagers.Sounds.PlaySound(isJoker ? "cardOnWildCard" : "matchCard1");
        };

        PyramidInputInterpreter.prototype.ClickEmptyPile = function (pileClicked) {
            var supply = pileClicked.Pile.Supply;
            var action = new CardAction(supply);
            action.Parse(["noop"]);

            if (!this.InputEnabled) return action;

            var pile = pileClicked.Pile;

            if (pile.Name == "Stock") {
                var wastePile = supply.GetPile("Waste");
                action.Parse(["move", "Waste", "Stock", (-wastePile.Count).toString()]);

                if (action.IsAllowed()) {
                    EngineManagers.Sounds.PlaySound("drawReset");
                }
            }

            return action;
        };

        PyramidInputInterpreter.prototype.ClickOutside = function () {
            this.ClearHighlight();
        };


        PyramidInputInterpreter.prototype.IsCardHighlighted = function () {
            return (this.HighlightedCard != null);
        }

        PyramidInputInterpreter.prototype.GetHighlightedCard = function () {
            return this.HighlightedCard;
        }

        PyramidInputInterpreter.prototype.HighlightCard = function (card) {
            this.ClearHighlight();
            this.HighlightedCard = card;
            this.HighlightedCard.Highlight();
            this.HighlightTime = EngineManagers.Time.TotalGameTime.TotalMilliseconds;
            Debug.log("HighlightCard " + card.Card);

            EngineManagers.Sounds.PlaySound("pickupCard");
            // notify UI?
        };

        PyramidInputInterpreter.prototype.ClearHighlight = function () {
            if (this.HighlightedCard != null) {
                this.HighlightedCard.ClearHighlight();
                this.HighlightedCard = null;
                this.HighlightTime = -1;
            }
            //Console.WriteLine("ClearHighlight()");
            // notify UI?
        };

        PyramidInputInterpreter.prototype.ShouldMoveKeyboard = function (action, card) {
            if (!this.InputEnabled) return false;
            for (var i = 0; i < action.Ops.length; i++) {
                var op = action.Ops[i];
                if (op.Opcode == CardOp.Op.Move) {
                    var SourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
                    var DestPile = op.GetPile(CardOp.eMoveParams.DestPile);
                    if (SourcePile.Name != "Stock" && SourcePile.Name != "Waste") {
                        if (SourcePile.Top == card ||
                            DestPile.Top == card
                            || DestPile.NthFromTop(2) == card)
                            return true;
                    }
                }
            }
            return false;
        };

        PyramidInputInterpreter.prototype.DealNextFromStock = function (supplyView) {
            var cardSupply = this.Authority.CardSupply;
            var action = new CardAction(cardSupply);
            var cardsInWaste = cardSupply.GetPile("Waste").Count;

            if (cardSupply.GetPile("Stock").Empty) {
                action.Parse(["begin", "move", "Waste", "Stock", "-" + cardsInWaste, "end"]);
                if (action.IsAllowed())
                    EngineManagers.Sounds.PlaySound("drawReset");
            }
            else {
                action.Parse(["begin", "move", "Stock", "Waste", "1", "end"]);
                if (action.IsAllowed())
                    EngineManagers.Sounds.PlaySound("singleCard");
            }
            action.Run();

            if (this.GetHighlightedCard() && (this.GetHighlightedCard().Card.Pile.Type == "Stock" || this.GetHighlightedCard().Card.Pile.Type == "Waste")) {
                this.ClearHighlight();
            }
        };

        return PyramidInputInterpreter;

    });
